import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { environment } from "../../../../../environments/environment";
import {
  MappedRetrieveWeeksListAbsenceResponse,
  RetrievePlanningMapped,
} from "../../../../domain/models/personnel.model";
import { RolesGridRow } from "../../../../domain/models/roles-grid";
import { DeleteAbsenceUseCase } from "../../../../domain/use-cases/personnel/delete-absence.usecase";
import { RetrievePlanningUseCase } from "../../../../domain/use-cases/personnel/retrieve-planning.usecase";
import { RetrieveWeeklyAbsenceUseCase } from "../../../../domain/use-cases/personnel/retrieve-weekly-absence.usecase";
import { RetrieveWeeksListAbsenceUseCase } from "../../../../domain/use-cases/personnel/retrieve-weeks-list-absence.usecase";

@Injectable({
  providedIn: "root",
})
export class PersonnelService {
  constructor(
    private http: HttpClient,
    private retrievePlanningUseCase: RetrievePlanningUseCase,
    private retrieveWeeksListAbsenceUseCase: RetrieveWeeksListAbsenceUseCase,
    private deleteAbsenceUseCase: DeleteAbsenceUseCase,
    private retrieveWeeklyAbsenceUseCase: RetrieveWeeklyAbsenceUseCase,
  ) {}

  weeksListAbsence(): Observable<MappedRetrieveWeeksListAbsenceResponse> {
    return this.retrieveWeeksListAbsenceUseCase.execute();
  }

  resourcePlanning(resourceId: any): Observable<RetrievePlanningMapped> {
    return this.retrievePlanningUseCase.execute({ resourceId });
  }

  deleteAbsence(req: any): Observable<any> {
    return this.deleteAbsenceUseCase.execute(req);
  }

  getWeeklyAbsence(resourceId: number): Observable<any> {
    return this.retrieveWeeklyAbsenceUseCase.execute({ resourceId });
  }

  setWeeklyAbsence(req: any) {
    return this.http.post(
      `${environment.apiUrl}/hr/resource/${req.resourceId}/absence`,
      { absenceDto: req },
    );
  }

  setSmarts(req: any, resourceId: number) {
    return this.http.put(`${environment.apiUrl}/hr/${resourceId}/smarts`, {
      levelResourcePlanningDtos: req,
    });
  }

  fetchResourceRoles(resourceId: number) : Observable<RolesGridRow[]> {
    return this.http
      .get<ProjectRolesByResourceResponse>(
        `${environment.apiUrl}/hr/resource/project-roles`,
        { params: { resourceId } },
      )
      .pipe(map((res) => res.projectRoleByResource));
  }

  retrieveAgreementInfoByCode(code: string) {
    return this.http
      .get<AgreementInfoResponse>(`${environment.apiUrl}/sm/agreementInfo`, {
        params: { code },
      })
      .pipe(map((res) => res.agreementInfo));
  }
}

export interface AgreementInfoResponse {
  agreementInfo: {
    agreementId: number;
    level: number;
  };
}

export interface ProjectRolesByResourceResponse {
  projectRoleByResource: RolesGridRow[];
}
